const quietly = (load) => Promise.resolve()
  .then(load)
  .catch((e) => {
    // Nobody asked for this lookup, so its failure is not the user's to be told about.
    if (e) e.handled = true;
    throw e;
  });

/**
 * Loads the branch context the branch-aware screens read, from whichever entry point got here
 * first.
 *
 * A tenant whose branches were never loaded reads as a single-branch one everywhere -- the columns,
 * filters and selectors disappear and the switcher hides -- so this cannot be left to one entry
 * point. There are two: a reload, which runs App.vue's created hook with a session already in
 * place, and a sign-in, which is an in-app route change that hook has long since passed.
 *
 * Nothing is asked for before there is a session, or while a forced password change is still
 * outstanding, since branch access is not the user's yet. A lookup that fails leaves the screens on
 * their own fallbacks rather than failing the caller, which on the sign-in path is the sign-in.
 *
 * The branch list is a multiple-branches endpoint: a club without the feature is refused it with
 * FeatureNotInPackage, so it is not asked for -- that club has one branch and nothing to switch.
 */
export default async function bootstrapBranchContext({
  userData, hasMultipleBranches, loadAccess, loadBranches, dispatch,
}) {
  if (!userData || userData.requiresChangePasswordOnLogin) return;

  try {
    const [access, branchesResponse] = await Promise.all([
      quietly(loadAccess),
      hasMultipleBranches ? quietly(loadBranches) : [],
    ]);
    await dispatch('initializeBranchContext', { access, branchesResponse });
  } catch (e) {
    // Branch-aware screens retain their existing local fallbacks if bootstrap is unavailable.
  }
}
